import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// All requests go to the same-origin /api prefix.
// Dev: Vite proxies /api/* → backend (vite.config.mjs).
// Prod: Express (server.js) proxies /api/* → backend.
// This prevents CORS preflight issues for custom headers like redirectURL.
const BASE_URL = '/api';

export const baseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	credentials: 'include',

	prepareHeaders: (headers, { getState }) => {
		const accessToken = getState().auth.accessToken;

		if (accessToken) {
			headers.set('Authorization', `Bearer ${accessToken}`);
		}

		if (!headers.has('Content-Type')) {
			headers.set('Content-Type', 'application/json');
		}

		return headers;
	},
});

// rawBaseQuery — no Authorization header, used for the refresh endpoint.
// Prevents a 401 loop: if the access token is expired and we used baseQuery to call
// /v1/user/refreshToken, it would inject the expired token → server returns 401 again.
export const rawBaseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	credentials: 'include',
	prepareHeaders: (headers) => {
		if (!headers.has('Content-Type')) {
			headers.set('Content-Type', 'application/json');
		}
		return headers;
	},
});
